import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../state'

import * as form from './form'

/**
 * Centered modal that lets the user configure an agent's
 * {@link ents.core.agent.Configuration.Context} at two scopes:
 *
 *  - **Agent default** — applied to every conversation with the agent.
 *  - **This conversation** — overrides the agent default for one
 *    conversation. Disabled when no conversation is selected.
 *
 * The modal owns no editing state of its own — every interaction is a
 * dispatch into the configuration feature, and every value rendered is
 * sourced from a selector. The host renders this component based on
 * the feature's `isEditing` selector.
 */
@ngCore.Component({
  imports: [
    ds.button.Component,
    ds.layout.widget.Component,
    ds.overlay.centered.Component,
    ds.tabs.integratedHorizontal.Component,
    ds.tabs.tab.Directive,
    form.Component,
  ],
  selector: 'atn-assistant-configuration',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.assistant.configuration.Feature} */
  public readonly feature = ngCore.inject(state.assistant.configuration.Feature)
  /** */
  public readonly modeSg = ngCore.model<'agent' | 'conversation'>('agent')
}
